import React from 'react'
import { Link } from 'react-router-dom'
import { all_routes } from '../../../router/all_routes'
import { scrollToSection } from '../../../../utility/scrollToSection'

const Instructor = () => {


    const route = all_routes;

    const handlePartnerClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        scrollToSection('partnership-form');
    };

    return (
        <>
            <section className="home-five-become">
                <div className="container">
                    <div className="row align-items-center row-gap-4">
                        <div className="col-lg-8 col-md-8" data-aos="fade-up">
                            <div className="become-content-three">
                                <h3>Ready to elevate your recruitment with unmatched quality, streamlined efficiency, and full control.</h3>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-4" data-aos="fade-up">
                            <div className="text-end">
                                <a href="#partnership-form" className="btn btn-white" onClick={handlePartnerClick}>
                                    Partner with Us Now
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>

    )
}

export default Instructor
